export const adminSignIn = `mutation adminSignIn($email: String! $password: String!) {
  adminSignIn(email: $email, password: $password) {
    user {
      firstName
    }
    token
  }
}`

export const confirmUser = `mutation confirmUser($token: String!) {
  confirmUser(token: $token)
}`

export const createArea = `mutation createArea($name: String! $lat: Float! $lng: Float!, $emailNotificationRadius: Int) {
  createArea(
    name: $name
    emailNotificationRadius: $emailNotificationRadius
    location: {
      address: ""
      lat: $lat
      lng: $lng
    }) {
      id
      activeYouthCount
      approvedBusinessesCount
      availableYouthCount
      emailNotificationRadius
      hourLoggingYouthCount
      jobListingsCount
      location {
        lat
        lng
        address
      }
      name
      new30DaysBusinessesCount
      new30DaysYouthCount
      notes
      relevantBusinessesCount
      relevantYouthCount
      vacantPositionsCount
      lessThanFourteenYouthCount
      fourteenFifteenYouthCount
      sixteenYouthCount
      seventeenYouthCount
      eighteenYouthCount
      nineteenTwentyYouthCount
      twentyOneTwentyFiveYouthCount
      overTwentySixYouthCount
    }
}`

export const createAuthority = `mutation createAuthority($searchText: String!) {
  createAuthority(
    searchText: $searchText
) {
    isArchived
    id
    notes
    gmapsLocalityId
    name
  }
}
`

export const forgotPassword = `mutation forgotPassword($email: String!) {
  forgotPassword(email: $email)
}`

export const disallowEmailNotifications = `mutation disallowEmailNotifications {
  disallowEmailNotifications
}`

export const resetPassword = `mutation resetPassword($password: String!) {
  resetPassword(password: $password)
}`

export const createUser = `mutation createUser(
  $address: String
  $birthday: DateTime
  $business: CreateBusinessInput
  $email: String!
  $firstName: String
  $image: String
  $lastName: String
  $password: String!
  $phone: String
  $role: Role!
  $weeklyDayOff: Weekday
) {
  createUser(
    input: {
      address: $address
      birthday: $birthday
      business: $business
      email: $email
      firstName: $firstName
      image: $image
      isConfirmed: true
      lastName: $lastName
      password: $password
      phone: $phone
      role: $role
      weeklyDayOff: $weeklyDayOff
    }
  ) {
    id
    email
    firstName
    lastName
    role
    phone
  }
}`

export const createJob = `mutation createJob($name: String!, $address: String!, $branch: ID!) {
  createJob(name: $name, address: $address, branch: $branch) {
    id
    name
    isVerified
    address
    branch {
      id
      name
    }
    users {
      id
    }
  }
}`

export const createRuleEngineAlgorithm = `mutation ($input: CreateRuleEngineAlgorithmInput!) {
  createRuleEngineAlgorithm(input: $input) {
    id
  }
}`

export const updateEmployer = `mutation (
  $id: ID!
  $address: String
  $birthday: DateTime
  $business: UpdateBusinessInput
  $email: String
  $firstName: String
  $image: String
  $isArchived: Boolean
  $lastName: String
  $phone: String
  $password: String
  $role: Role
) {
  updateUser(
    whereId: $id
    data: {
     address: $address
     birthday: $birthday
     business: $business
     email: $email
     firstName: $firstName
     image: $image
     isArchived: $isArchived
     lastName: $lastName
     phone: $phone
     password: $password
     role: $role
    }
  ) {
    id
    address
    authority {
      id
      name
      isActive
      isArchived
    }
    birthday
    business {
      name
      isApproved
      address
      branch {
        id
        name
      }
    }
    closestArea {
      id
      name
      isArchived
    }
    createdAt
    email
    firstName
    image
    isArchived
    isConfirmed
    lastActivity
    lastName
    phone
    role
  }
}
`

export const updateRuleEngineAlgorithm = `mutation (
    $id: ID!
    $input: UpdateRuleEngineAlgorithmInput!
  ) {
  updateRuleEngineAlgorithm(
    whereId: $id
    data: $input
  ) {
    id
  }
}`

export const updateUser = `mutation (
  $id: ID!
  $isArchived: Boolean
  $firstName: String
  $lastName: String
  $email: String
  $phone: String
  $password: String
  $role: Role
) {
  updateUser(
    whereId: $id
    data: {
     firstName: $firstName
     lastName: $lastName
     email: $email
     role: $role
     phone: $phone
     password: $password
     isArchived: $isArchived
    }
  ) {
    id
    authority {
      id
      name
      isActive
      isArchived
    }
    birthday
    closestArea {
      id
      name
      isArchived
    }
    createdAt
    email
    firstName
    image
    isArchived
    isConfirmed
    lastActivity
    lastName
    phone
    role
  }
}
`

export const updateJob = `mutation (
  $id: ID!
  $name: String
  $isVerified: Boolean
  $isArchived: Boolean
  $address: String
  $branch: ID
) {
  updateJob(
    whereId: $id
    data: {
     name: $name
     isVerified: $isVerified
     isArchived: $isArchived
     address: $address
     branch: $branch
    }
  ) {
      id
      name
      isVerified
      address
      branch {
        id
        name
      }
      users {
        id
      }
    }
}`

export const updateBranch = `mutation (
  $id: ID!
  $name: String
  $image: String
  $isArchived: Boolean
) {
  updateBranch(
    whereId: $id
    data: {
      name: $name
      image: $image
      isArchived: $isArchived
    }
  ) {
    id
    name
    image
    jobs {
      name
      id
    }
  }
}`

export const createBranch = `mutation (
  $name: String!
  $image: String
) {
  createBranch (
    name: $name
    image: $image
  ) {
    id
    name
    image
    jobs {
      id
      name
    }
  }
}`

export const createArticle = `mutation createArticle(
  $title: String!
  $subtitle: String!
  $text: String!
  $image: String
  $tags: [ArticleTag!]!
  $targetAudience: TargetAudience!
  ) {
    createArticle(
    input: {
      title: $title
      subtitle: $subtitle
      text: $text
      image: $image
      tags: $tags
      targetAudience: $targetAudience
    }
  ) {
    id
    createdAt
    title
    subtitle
    text
    image
    author {
      email
    }
    tags
  }
}`

export const updateArea = `mutation updateArea(
  $id: ID!
  $name: String
  $location: LocationInput
  $emailNotificationRadius: Int
  $isArchived: Boolean
  $notes: String
) {
  updateArea(
    whereId: $id
    name: $name
    location: $location
    emailNotificationRadius: $emailNotificationRadius
    isArchived: $isArchived
    notes: $notes
  ) {
    id
    activeYouthCount
    approvedBusinessesCount
    availableYouthCount
    emailNotificationRadius
    hourLoggingYouthCount
    jobListingsCount
    location {
      lat
      lng
      address
    }
    name
    new30DaysBusinessesCount
    new30DaysYouthCount
    notes
    relevantBusinessesCount
    relevantYouthCount
    vacantPositionsCount
  }
}`

export const updateAuthority = `mutation updateAuthority(
  $id: ID!
  $isArchived: Boolean
  $logo: String
  $leadArticle: UpsertArticleInput
  $mayor: String
  $mayorPic: String
  $message: String
  $isActive: Boolean
  $name: String
  $notes: String
) {
  updateAuthority(
  whereId: $id
  data: {
    isArchived: $isArchived
    isActive: $isActive
    logo: $logo
    leadArticle: $leadArticle
    mayor: $mayor
    mayorPic: $mayorPic
    message: $message
    name: $name
    notes: $notes
  }) {
    id
    createdAt
    isArchived
    activeYouthCount
    approvedBusinessesCount
    availableYouthCount
    gmapsLocalityId
    gmapsName
    hourLoggingYouthCount
    jobListingsCount
    logo
    leadArticle {
      id
      createdAt
      title
      subtitle
      text
      image
      author{
        id
        email
        firstName
        lastName
      }
      tags
      isArchived
      likes {
        id
        firstName
        lastName
      }
    }
    mayor
    mayorPic
    message
    name
    new30DaysBusinessesCount
    new30DaysYouthCount
    notes
    relevantBusinessesCount
    relevantYouthCount
    usersCount
    vacantPositionsCount
  }
}`

export const updateJobListing = `mutation updateJobListing(
  $id: ID!
  $data: UpdateJobListingInput!
  $isBlocking: Boolean
) {
  updateJobListing(
    whereId: $id
    data: $data
    isBlocking: $isBlocking
    ) {
    airsAt
    business {
      id
    }
    allowEmailNotifications
    createdAt
    description
    endTime
    expiresAt
    hourlyRate
    id
    image
    isAcceptingInAppApplications
    isAccessibleForTheDisabled
    isBlocked
    isBreaks
    isInShifts
    isOnSaturday
    isOvertime
    isPaidTraining
    isPublicTransportationAccessible
    isSalaryRaisable
    isShuttles
    isTips
    isTravelsRefunded
    jobsAmount
    jobsMannedAmount
    likes {
      id
    }
    logoImage
    minimumAge
    name
    phone
    requirements
    salaryType
    startTime
    weeklyWorkDays
    whatsapp
  }
}`

export const updateJobListingExpiry = `mutation updateJobListingExpiry($id: ID!, $expiresAt: DateTime!) {
  updateJobListing(
    whereId: $id
    data: { expiresAt: $expiresAt }
  ) {
    id
    expiresAt
  }
}`

export const createJobListing = `mutation createJobListing($input: CreateJobListingInput!) {
  createJobListing(input: $input) {
    id
  }
}`

export const updateArticle = `mutation updateArticle(
  $id: ID!
  $title: String
  $subtitle: String
  $text: String
  $image: String
  $tags: [ArticleTag!]
  $isArchived: Boolean
  $targetAudience: TargetAudience
  ) {
  updateArticle(
    whereId: $id
    data: {
      title: $title
      subtitle: $subtitle
      text: $text
      image: $image
      tags: $tags
      isArchived: $isArchived
      targetAudience: $targetAudience
    }
  ) {
    id
    createdAt
    title
    targetAudience
    subtitle
    text
    image
    author {
      email
    }
    tags
  }
}`

export const updateConfiguration = `mutation updateConfiguration($key: String! $value: String!) {
  updateConfiguration(key: $key value: $value) {
    id
    key
    value
  }
}`

export const upsertJobListingPlanConfiguration = `mutation upsertJobListingPlanConfiguration(
  $data: JobListingPlanConfigurationInput!
) {
  upsertJobListingPlanConfiguration(
    data: $data
  ) {
    id
    plan
    title
    price
    description
    publishDuration
    applicationAmount
    publishButton
    featuresTitle
    features {
      id
      text
      toolTipText
    }
  }
}`
